import { Injectable } from '@angular/core';
import { MarketplaceBasket } from './models/basket/marketplace-basket.model';
import { MarketplaceBasketItem } from './models/basket/marketplace-basket-item.model';
import { Observable, BehaviorSubject } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { LoggingService } from '../../shared/services/core/logging.service';
import { isEqual } from '../../shared/utility-functions';
import { ApiService } from '../../shared/services/core/api.service';

@Injectable({
  providedIn: 'root',
})
export class BasketService {
  private _basket: BehaviorSubject<MarketplaceBasket> = new BehaviorSubject<MarketplaceBasket>(new MarketplaceBasket());
  basket$: Observable<MarketplaceBasket> = this._basket.asObservable().pipe(shareReplay(1));

  constructor(
    private logService: LoggingService,
    private api: ApiService
  ) {}

  /** Gets the current basket. */
  getCurrentBasket(): MarketplaceBasket {
    return this._basket.value;
  }

  /** Adds an item to the basket. */
  addItemToBasket(item: MarketplaceBasketItem): void {
    let basket = this.getCurrentBasket();
    let existingItem = basket.items.find((i) => {
      return i.id === item.id && i.attributeMappingId == item.attributeMappingId && isEqual(item.customFields, i.customFields);
    });

    if (existingItem) {
      existingItem.quantity += existingItem.quantity;
    } else {
      basket.items.push(item);
    }

    this._basket.next(basket);
  }

  /** Removes an item from the basket. */
  removeItemFromBasket(productId: number): void {
    let basket = this.getCurrentBasket();
    let existingItem = basket.items.find((item) => item.id === productId);

    if (!existingItem) {
      this.logService.warning(`Failed to remove item ${productId} from basket as this item is not in the basket.`);
      return;
    }

    if (existingItem.quantity > 1) {
      existingItem.quantity -= 1;
    } else {
      basket.items = basket.items.filter((item) => item.id !== existingItem!.id);
    }

    this._basket.next(basket);
  }

  /** Clears the basket of all items. */
  emptyBasket(): void {
    this._basket.next(new MarketplaceBasket());
  }

  async getPurchasesOrderBasket(orderId: string) {
    return await this.api.get(`purchases/order/basket/${orderId}`).toPromise();
  }

  /** Version 2 */
  getOrderDetails(orderId: string): Observable<any> {
    return this.api.get(`purchases/order/basket/${orderId}`);
  }
}
